<template>
  <div class="m-activity-ticketSet">
    <div class="title">门票设置</div>
    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="100px">
      <el-form-item label="报名方式" prop="free">
        <el-radio-group v-model="form.free" @input="freeChange" :disabled="baseInfo.startSignUp">
          <el-radio :label="true">免费参与</el-radio>
          <el-radio :label="false">组合参与</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="允许单用户参与场次" prop="participateCount" >
        <el-input v-model="form.participateCount" placeholder="请输入允许单用户参与场次" :disabled="!isEdit" oninput="value=value.replace(/[^\d]+/g,'')"/>
      </el-form-item>
    </el-form>
    <div class="tabs-box">
      <auth-button auth="market:activity:update" v-if="isCanBaseInfoEdit">
        <el-button  class="add-btn" type="primary" @click="onAddTicket">+ 添加门票</el-button>
      </auth-button>
      <el-tabs v-model="tabsKey" type="card" :closable="ticketListData.length > 1" @tab-remove="onDelPrize" :before-leave="onTabClick" :key="tabsKeyValue">
        <el-tab-pane
          v-for="(ticketItem, ticketIndex) in ticketListData"
          :label="`门票` + (ticketIndex + 1)"
          :key="ticketIndex"
          :name="`${ticketIndex}`"
        >
          <TicketForm
            :baseInfo="baseInfo"
            :ticketListData="ticketListData"
            :ticketItem="ticketItem"
            :ticketIndex="ticketIndex"
            :tabsKey="tabsKey"
            :free="form.free"
            :participateCount="form.participateCount"
            :isCanBaseInfoEdit="isCanBaseInfoEdit"
            @onIsEdit="onIsEdit"
            @getTicketData="getTicketData"
            @delTicketOk="delTicketOk"
          ></TicketForm>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import { api_getApplyTicketList, api_putTicketDel, api_putTicketDelAll } from '@/api/market'
import TicketForm from './ticketForm.vue'

export default {
  name: "marketActivityListAddPrizes",
  components: {
    AuthButton,
    TicketForm,
  },
  props: {
    baseInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    isCanBaseInfoEdit: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  data() {
    return {
      form: {
        free: true,
        participateCount:1,
      },
      rules: {
        free: [{ required: true, message: '请选择报名方式' }],
        participateCount: [{ required: true, message: '请输入允许单用户参与场次' }],
      },
      submitLoading: false, // 确定按钮加载loading
      tabsKeyValue: false, // tabs组件key
      tabsKey: '0', // tabs绑定key
      isCanChangeTabs: false, // 是否可以添加、切换tab
      ticketListData: [
        {
          isEdit: true
        }
      ], // 门票list数据
      isEdit:false,//是否在编辑门票
    };
  },
  created() {
    if (this.$route.query.id) {
      this.getTicketData() // 获取门票数据
    }
  },
  methods: {
    // 获取门票数据
    async getTicketData() {
      const { id, page } = this.$route.query
      const res = await api_getApplyTicketList({activityId: id})
      console.log('门票res: ', res);
      this.ticketListData = res
      this.tabsKeyValue = !this.tabsKeyValue

      if (!res.length) {
        this.ticketListData = [{isEdit: true}]
        this.isCanChangeTabs = false
        this.isEdit = true
      } else {
        this.isCanChangeTabs = true
        this.form.free = res.length ? res[0].free : true
        this.form.participateCount =  this.ticketListData[0].participateCount
      }
    },

    // 点击切换tab（切换tab之前触发）
    onTabClick(newKey, oldKey) {
      if (!this.isCanChangeTabs) {
        this.$baseMessage('请先保存当前奖品信息', 'warning')
        return false
      }
      if (this.ticketListData[this.tabsKey] && this.ticketListData[this.tabsKey].isEdit || !this.ticketListData[this.tabsKey]) {
        this.isCanChangeTabs = false
      }
      this.tabsKey = newKey
    },

    // 改变当前是否可以切换tab的状态
    onIsEdit(status) {
      this.ticketListData[this.tabsKey].isEdit = status
      this.tabsKeyValue = !this.tabsKeyValue // 重新渲染
      this.isCanChangeTabs = !status
      this.isEdit = status
    },

    // 点击添加
    onAddTicket() {
      if (!this.isCanChangeTabs) {
        this.$baseMessage('请先保存当前门票信息', 'warning')
      } else {
        this.ticketListData.push({isEdit: true})
        this.onTabClick(this.ticketListData.length - 1 + '')
        this.isEdit = true
      }
    },

    // 点击删除门票
    onDelPrize(targetName) {
      this.$baseConfirm(
        `是否删除该门票？`,
        {title: '提示', type: 'warning',},
        async () => {
          if (this.ticketListData[targetName].id) {
            await api_putTicketDel({id: this.ticketListData[targetName].id})
          }
          this.delTicketOk(targetName)
        })
    },

    // 确认删除门票
    delTicketOk(targetName) {
      if (this.tabsKey == this.ticketListData.length - 1) {
        this.tabsKey = `${this.ticketListData.length - 2}`
      }
      this.ticketListData.splice(targetName, 1)
      this.isCanChangeTabs = true
      this.getTicketData() // 获取门票数据
      this.isEdit = false
    },

    // 切换报名方式
    freeChange(value) {
      if (this.ticketListData.length && this.ticketListData[0].id) {
        this.form.free = value ? false : true
        this.$baseConfirm(
          `当前报名方式下的门票信息将清空，是否切换报名方式？`,
          {title: '提示', type: 'warning',},
          async () => {
            const { id } = this.$route.query
            let res = await api_putTicketDelAll({activityId: id})
            this.form.free = value
            this.onIsEdit(false)
            this.getTicketData() // 获取门票数据
          },
        )
      }
    }

  },
};
</script>

<style lang="scss" scoped>
.m-activity-ticketSet {
  width: 100%;
  margin-top: 50px;
  box-sizing: border-box;
  position: relative;

  .add-btn {
    margin-bottom: 20px;
  }

  .tabs-box {
    padding-left: 100px;
  }

  // 奖品设置
  .prizes-box {

    .prizes-list-box {

      .prizes-item {
        .item-form-box {
          margin-top: 20px;
        }
      }
    }

    .add-btn {
      margin-left: 80px;
    }

  }

  .el-input,
  .el-textarea,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 400px;
  }


  .title {
    margin: 0;
    margin-bottom: 10px;
    padding-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }
  }

  .footer{
    text-align: right;
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
    right: 0;
    z-index: 999;

    .mr100 {
      margin-right: 100px;
    }
  }
}
</style>
